import {Dto} from "common";

export class AcceptParticipantShareDto extends Dto {
    token: string;

    deserialize(input: any): this {
        Object.assign(this, input);
        return this;
    }
}
